import { ttcabinetsConstants } from '../constants/ttcabinets';

const initialState = {
  currentState: 'loading',
  countries: [],
  categories: [],
  cabinets: [],
  error: '',
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case ttcabinetsConstants.SET_REQUEST_IN_PROGRESS:
      return { ...state, currentState: 'loading', error: initialState.error };
    case ttcabinetsConstants.SET_SELECT_OPTIONS_SUCCESS:
      return {
        ...state,
        currentState: 'ready',
        countries: action.payload.countries,
        categories: action.payload.categories,
        error: initialState.error,
      };
    case ttcabinetsConstants.SET_CABINETS_SUCCESS:
      return { ...state, currentState: 'ready', cabinets: action.payload };
    case ttcabinetsConstants.SET_SELECT_OPTIONS_FAILURE:
    case ttcabinetsConstants.SET_CABINETS_FAILURE:
      return { ...state, currentState: 'error', error: action.payload };
    default:
      return state;
  }
};
